<template>
  <section class="hero-slider" @mouseover="stopAutoSlide" @mouseleave="startAutoSlide">
    <div class="slides">
      <div
        class="slide"
        v-for="(image, index) in images"
        :key="index"
        :class="{ active: index === currentSlide }"
        :style="{ backgroundImage: `url(${image})` }"
      >
        <div class="slide-content">
          <h2 class="slide-title">Bienvenue sur Prymo</h2>
          <p class="slide-text" style="font-size: 28px; font-family: 'Public Sans', sans-serif;">Des solutions numériques pour une Afrique connectée</p>
          <router-link to="/contact" class="cta-button">Contactez-nous</router-link>
        </div>
      </div>
    </div>

    <!-- Navigation Arrows -->
    <div class="slider-controls">
      <button @click="prevSlide" class="control-button">❮</button>
      <button @click="nextSlide" class="control-button">❯</button>
    </div>

    <!-- Navigation Dots -->
    <div class="slider-dots">
      <span
        v-for="(image, index) in images"
        :key="index"
        :class="{ active: index === currentSlide }"
        @click="goToSlide(index)"
      ></span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Section1View',
  data() {
    return {
      currentSlide: 0,
      autoSlideInterval: null,
      images: [
        require('@/assets/slides/slide1.jpg'),
        require('@/assets/slides/slide2.jpg'),
        require('@/assets/slides/slide3.jpg'),
      ]
    };
  },
  methods: {
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.images.length;
    },
    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.images.length) % this.images.length;
    },
    goToSlide(index) {
      this.currentSlide = index;
    },
    startAutoSlide() {
      this.autoSlideInterval = setInterval(this.nextSlide, 2000);
    },
    stopAutoSlide() {
      clearInterval(this.autoSlideInterval);
    },
  },
  mounted() {
    this.startAutoSlide();
  },
  beforeUnmount() {
    this.stopAutoSlide();
  }
};
</script>

<style scoped>
.hero-slider {
  position: relative;
  height: 80vh;
  min-height: 600px;
  overflow: hidden;
}

.slides {
  height: 100%;
  width: 100%;
  position: relative;
}

.slide {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0;
  transition: opacity 1s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.slide::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 0;
}

.slide.active {
  opacity: 1;
  z-index: 1;
}

.slide-content {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 0 2rem;
  max-width: 800px;
  animation: fadeUp 1s ease-out;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.slide-title {
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.slide-text {
  font-size: 1.5rem;
  margin-bottom: 2rem;
  text-shadow: 0 1px 3px rgba(0,0,0,0.3);
}

.cta-button {
  background: #42b983;
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  font-size: 1rem;
  border-radius: 30px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
}

.cta-button:hover {
  background: #2c3e50;
}

/* Controls */
.slider-controls {
  position: absolute;
  top: 50%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 2rem;
  transform: translateY(-50%);
  z-index: 5;
}

.control-button {
  background: rgba(255,255,255,0.3);
  color: white;
  font-size: 2rem;
  border: none;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  cursor: pointer;
  backdrop-filter: blur(5px);
  transition: all 0.3s ease;
}
.control-button:hover {
  background: #42b983;
}

/* Dots */
.slider-dots {
  position: absolute;
  bottom: 30px;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 10px;
  z-index: 5;
}

.slider-dots span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255,255,255,0.5);
  cursor: pointer;
  transition: all 0.3s ease;
}
.slider-dots span.active {
  background: #42b983;
  transform: scale(1.2);
}
</style>
